// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"457":"9698ae77","563":"80e0e0b2","891":"dac3ad35"}[chunkId] + ".css";
};